<template>
  <qx-card-form title="线路信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <TransAddress
        slot="address"
        :middleData="otherFormData.middleData"
        :transportPointName="{ transPointName: '停经点' }"
        @add="addMiddle"
        @del="delMiddle"
      >
        <!-- 起点 -->
        <section slot="start">
          <el-form-item label="导航地址">
            <ChooseAddressMap v-model="otherFormData.sourceAddress" @cc="onChangeSource" />
          </el-form-item>
          <el-form-item label="出发地址">
            <el-input
              class="norderFormWidth"
              v-model="otherFormData.navigatSourceLocation"
              placeholder="请输入"
            />
          </el-form-item>
        </section>
        <!-- 起点 end -->
        <!-- 中间 -->
        <section
          v-for="(item, index) in otherFormData.middleData"
          :key="item.id"
          :slot="'middle' + index"
        >
          <el-form-item label="导航地址">
            <ChooseAddressMap
              v-model="otherFormData.middleData[index].desAddress"
              @cc="(data)=>onChangeMiddle(data,index)"
            />
          </el-form-item>
          <el-form-item label="途经地址">
            <el-input
              class="norderFormWidth"
              v-model="otherFormData.middleData[index].navigatDesLocation"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="到达时限">
            <el-input
              class="norderFormWidth"
              v-model="otherFormData.middleData[index].arriveTime"
              @blur="arriveTime(index)"
              placeholder="请输入"
            >
              <span slot="suffix" class="inputSlotText">小时</span>
            </el-input>
          </el-form-item>
        </section>
        <!-- 中间 end -->
        <!-- 终点 -->
        <section slot="end">
          <el-form-item label="导航地址">
            <ChooseAddressMap v-model="otherFormData.desAddress" @cc="onChangeDes" />
          </el-form-item>
          <el-form-item label="目的地址">
            <el-input
              class="norderFormWidth"
              v-model="otherFormData.navigatDesLocation"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="到达时限" :required="true">
            <el-input class="norderFormWidth" v-model="otherFormData.arriveTime" placeholder="请输入" @blur="arriveTime">
              <span slot="suffix" class="inputSlotText">小时</span>
            </el-input>
          </el-form-item>
        </section>
        <!-- 终点 end -->
      </TransAddress>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import TransAddress from 'components/transAddress';
import ChooseAddressMap from 'components/chooseAddressMap/chooseAddressMap';
import {
  calcDistance, isNegativeNumber,
} from '@qx/utils';
export default {
  components: {
    TransAddress,
    ChooseAddressMap,
  },
  data () {
    return {
      mapTar: '',
      otherFormData: {
        sourceAddress: {}, // 导航地址
        navigatSourceLocation: '', // 出发地址
        desAddress: {}, // 目的地址
        navigatDesLocation: '', // 目的地址
        arriveTime: '', // 到达时限
        middleData: [], // 经停点
        des: '', // 目的地省市区
        source: '', // 始发地省市区
      },
      baseForm: {
        inline: true,
        form: [
          {
            label: 'address',
            value: 'address',
            slot: true,
            allCustom: true,
          },
        ],
        rules: {
          address: [
            { required: true, message: '请输入线路信息', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      const formData = await this.sub();
      console.log(formData);
    },
    onChangeSource (data) {
      this.otherFormData.navigatSourceLocation = data.address;
      this.fnCalcDistance();
    },
    onChangeDes (data) {
      this.otherFormData.navigatDesLocation = data.address;
      this.fnCalcDistance();
    },
    onChangeMiddle (data, index) {
      this.otherFormData.middleData[index].navigatDesLocation = data.address;
      this.fnCalcDistance();
    },
    async fnCalcDistance () {
      const sourceEand = this.otherFormData.sourceAddress.lng;
      const sourceNand = this.otherFormData.sourceAddress.lat;
      const desEand = this.otherFormData.desAddress.lng;
      const desNand = this.otherFormData.desAddress.lat;
      const middleData = this.otherFormData.middleData;

      const sourceAddressDetail = this.otherFormData.sourceAddress.addressDetail;
      const desAddressDetail = this.otherFormData.desAddress.addressDetail;

      const sourceCityName = sourceAddressDetail.city + sourceAddressDetail.district;
      const desCityName = desAddressDetail.city + desAddressDetail.district;

      this.$emit('calcDistance', {
        state: 'start',
      });
      const distance = await calcDistance({
        sourceEand,
        sourceNand,
        desEand,
        desNand,
        sourceCityName,
        desCityName,
        middleData,
      });
      this.$emit('calcDistance', {
        state: 'finish',
        distance,
      });
    },
    // 获取变更的信息
    setData (data) {
      // 如果名字不一样，在这里设置成一样再 setVal
      // 把获取过来的信息设置到表单里面
      this.init(data.line);
    },
    showMap (tar) {
      this.mapTar = tar;
      this.$refs.mapDialog.show();
    },
    arriveTime (index) {
      this.otherFormData.arriveTime = isNegativeNumber(this.otherFormData.arriveTime);
      this.otherFormData.middleData[index].arriveTime = isNegativeNumber(this.otherFormData.middleData[index].arriveTime);
    },
    addMiddle (index) {
      if (index === undefined) {
        this.otherFormData.middleData.push({
          desAddress: {}, // 导航地址
          navigatDesLocation: '',
          arriveTime: '',
        });
      } else {
        this.otherFormData.middleData.splice(index + 1, 0, {
          desAddress: {}, // 导航地址
          navigatDesLocation: '',
          arriveTime: '',
        });
      }
    },
    delMiddle (index) {
      this.otherFormData.middleData.splice(index, 1);
      this.fnCalcDistance();
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        const subWayList = this.otherFormData.middleData.map((item) => ({ // 经停点
          desAddress: item.desAddress.address, // 目的地址
          desEand: item.desAddress.lng, // 目的地经度
          desNand: item.desAddress.lat, // 目的地纬度
          desProvince: item.desAddress.provinceId, // 目的地省ID
          desCity: item.desAddress.cityId, // 目的地市id
          desCounty: item.desAddress.countryId, // 目的地区id
          navigatDesLocation: item.navigatDesLocation, // 途经地址
          arriveTime: item.arriveTime, // 到达时间
        }));

        const desAddressDetail = this.otherFormData.desAddress.addressDetail;
        const sourceAddressDetail = this.otherFormData.sourceAddress.addressDetail;
        let des = this.otherFormData.desAddress.address;
        let source = this.otherFormData.sourceAddress.address;
        if (desAddressDetail.province && desAddressDetail.city && desAddressDetail.district) {
          des = desAddressDetail.province + desAddressDetail.city + desAddressDetail.district;
        }
        if (sourceAddressDetail.province && sourceAddressDetail.city && sourceAddressDetail.district) {
          source = sourceAddressDetail.province + sourceAddressDetail.city + sourceAddressDetail.district;
        }

        formData = {
          sourceAddress: this.otherFormData.sourceAddress.address, // 导航地址
          eand: this.otherFormData.sourceAddress.lng,
          sourceEand: this.otherFormData.sourceAddress.lng, // 始发经度
          nand: this.otherFormData.sourceAddress.lat,
          sourceNand: this.otherFormData.sourceAddress.lat, // 始发纬度
          sourceProvince: this.otherFormData.sourceAddress.provinceId, // 始发省id
          sourceCity: this.otherFormData.sourceAddress.cityId, // 始发市id
          sourceRegion: this.otherFormData.sourceAddress.cityId,
          sourceCounty: this.otherFormData.sourceAddress.countryId, // 始发县区id
          sourceRegionName: this.otherFormData.sourceAddress.sourceCityName,
          navigatSourceLocation: this.otherFormData.navigatSourceLocation, // 出发地址
          subWayList: cache ? subWayList : JSON.stringify(subWayList),
          desAddress: this.otherFormData.desAddress.address, // 目的地址
          desEand: this.otherFormData.desAddress.lng, // 目的地经度
          eandDes: this.otherFormData.desAddress.lng,
          desNand: this.otherFormData.desAddress.lat, // 目的地纬度
          nandDes: this.otherFormData.desAddress.lat,
          desProvince: this.otherFormData.desAddress.provinceId, // 目的地省ID
          desCity: this.otherFormData.desAddress.cityId, // 目的地市id
          desRegion: this.otherFormData.desAddress.cityId, // 目的地市id
          desCounty: this.otherFormData.desAddress.countryId, // 目的地县区id
          desRegionName: this.otherFormData.desAddress.desCityName,
          navigatDesLocation: this.otherFormData.navigatDesLocation, // 目的地址
          arriveTime: this.otherFormData.arriveTime, // 到达时限
          addrDtl: this.otherFormData.sourceAddress.address || '',
          desDtl: this.otherFormData.desAddress.address || '',
          des: des,
          source: source,
        };
      }
      return formData;
    },
    cacheData () {
      const res = this.handleSubData(true);
      return res;
    },
    checkOtherParams (message) {
      this.$message({
        type: 'warning',
        message,
      });
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        if (!formData.sourceProvince) {
          this.checkOtherParams('请填写线路始发地信息');
          return null;
        }
        if (!formData.desProvince) {
          this.checkOtherParams('请填写线路目的地信息');
          return null;
        }
        if (!formData.arriveTime) {
          this.checkOtherParams('请填写到达时限');
          return null;
        }
        let customerInfo = {};
        for (let name in formData) {
          if (formData[name] !== null && formData[name] !== undefined) {
            if (name === 'subWayList') {
              customerInfo['customerInfo.' + name + 'Str'] = formData[name];
            } else {
              customerInfo['customerInfo.' + name] = formData[name];
            }
          }
        }
        formData = customerInfo;
      }
      return formData;
    },
    setDetailData (data) {
      // 如果是修改模式
      if (data.transitLineInfos && data.transitLineInfos.length) {
        this.otherFormData.transitLineInfos = data.transitLineInfos;
        data.subWayList = data.transitLineInfos.map((item) => {
          item.desAddress = item.address;
          item.desEand = item.eand;
          item.desNand = item.nand;
          item.desProvince = item.province;
          item.desCity = item.region;
          item.desCounty = item.county;
          item.navigatDesLocation = item.navigatLocation;
          return item;
        });
      }

      if (data.orderGoods) {
        this.otherFormData.orderGoods = data.orderGoods;
        data.sourceAddress = data.orderGoods.navigatSourceLocation;
        data.sourceEand = data.orderGoods.eand;
        data.sourceNand = data.orderGoods.nand;

        data.desAddress = data.orderGoods.desDtl;
        data.desEand = data.orderGoods.eandDes;
        data.desNand = data.orderGoods.nandDes;

        data.navigatSourceLocation = data.orderGoods.navigatSourceLocation;
        data.navigatDesLocation = data.orderGoods.navigatDesLocation;
        data.des = data.orderGoods.des;
        data.source = data.orderGoods.source;
      }

      if (data.orderInfo) {
        this.otherFormData.orderInfo = data.orderInfo;
        data.sourceProvince = data.orderInfo.sourceProvince;
        data.sourceCity = data.orderInfo.sourceRegion;
        data.sourceCounty = data.orderInfo.sourceCounty;
        data.sourceRegionName = data.orderInfo.sourceRegionName;

        data.desProvince = data.orderInfo.desProvince;
        data.desCity = data.orderInfo.desRegion;
        data.desCounty = data.orderInfo.desCounty;
        data.desCityName = data.orderInfo.desRegionName;

        data.sourceProvinceName = data.orderInfo.sourceProvinceName;
        data.sourceRegionName = data.orderInfo.sourceRegionName;
        data.sourceCountyName = data.orderInfo.sourceCountyName;

        data.desProvinceName = data.orderInfo.desProvinceName;
        data.desRegionName = data.orderInfo.desRegionName;
        data.desCountyName = data.orderInfo.desCountyName;
      }

      if (data.orderScheduler) {
        this.otherFormData.orderScheduler = data.orderScheduler;
        data.arriveTime = data.orderScheduler.arriveTime;
      }
    },
    init (data = {}) {
      this.setDetailData(data);
      if (!data.subWayList) {
        data.subWayList = [];
      }
      this.otherFormData = {
        sourceAddress: {
          address: data.sourceAddress, // 导航地址
          lng: data.sourceEand, // 始发经度
          lat: data.sourceNand, // 始发纬度
          provinceId: data.sourceProvince, // 始发省id
          cityId: data.sourceCity, // 始发市id
          countryId: data.sourceCounty, // 始发县区id
          sourceRegionName: data.sourceCityName,
          addressDetail: {
            province: data.sourceProvinceName,
            city: data.sourceRegionName,
            district: data.sourceCountyName,
          },
        },
        navigatSourceLocation: data.navigatSourceLocation, // 出发地址
        middleData: data.subWayList.map((item) => ({
          desAddress: {
            address: item.desAddress, // 目的地址
            lng: item.desEand, // 目的地经度
            lat: item.desNand, // 目的地纬度
            provinceId: item.desProvince, // 目的地省ID
            cityId: item.desCity, // 目的地市id
            countryId: item.desCounty, // 目的地区id
          },
          navigatDesLocation: item.navigatDesLocation, // 途经地址
          arriveTime: item.arriveTime, // 到达时间
        })),
        desAddress: {
          address: data.desAddress, // 目的地址
          lng: data.desEand, // 目的地经度
          lat: data.desNand, // 目的地纬度
          provinceId: data.desProvince, // 目的地省ID
          cityId: data.desCity, // 目的地市id
          countryId: data.desCounty, // 目的地县区id
          desRegionName: data.desCityName,
          addressDetail: {
            province: data.desProvinceName,
            city: data.desRegionName,
            district: data.desCountyName,
          },
        },
        navigatDesLocation: data.navigatDesLocation, // 目的地址
        arriveTime: data.arriveTime, // 到达时限
        des: data.des,
        source: data.source,
      };
    },
  },
};
</script>

<style scoped lang="scss">
</style>
